<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M6.7 8c0-1.4.6-2.8 1.6-3.8s2.4-1.6 3.8-1.6 2.8.6 3.8 1.6 1.6 2.4 1.6 3.8-.6 2.8-1.6 3.8-2.4 1.6-3.8 1.6-2.8-.6-3.8-1.6c-1.1-1-1.6-2.4-1.6-3.8zm10.4 6.2c1.3-1 2.2-2.5 2.6-4.1.4-1.6.4-3.3-.2-4.8-.6-1.5-1.6-2.9-2.9-3.8C15.3.5 13.6 0 12 0S8.7.5 7.4 1.5C6.1 2.4 5 3.7 4.5 5.3c-.6 1.5-.6 3.2-.2 4.8.4 1.6 1.3 3 2.6 4.1C2.6 15.7 0 19 0 22.7c0 .4.1.7.4.9.2.3.6.4.9.4.4 0 .7-.1.9-.4.3-.2.4-.6.4-.9 0-3 3.1-6.7 9.3-6.7s9.3 3.6 9.3 6.7c0 .4.1.7.4.9.2.3.6.4.9.4s.7-.1.9-.4c.2-.2.4-.6.4-.9.2-3.7-2.4-7-6.7-8.5z"
    />
  </svg>
</template>
